import { IMenuItem, MenuItem } from "../MenuItem";
import { useCallback, useEffect } from "react";
import { clsx } from "clsx";
import { useAppStore } from "@/common/store/appStore";
import { useAccordion } from "@/common/hooks/useAccordion";
import { useActiveMenu } from "./hooks/useActiveMenu";
import "./BurgerMenuItem.scss";

interface IBurgerMenuItem extends IMenuItem {
  subNav?: IMenuItem[];
  delimiter?: boolean;
  onSetActiveMenuItem: (title: string) => void;
  activeMenuItem: string;
}

export const BurgerMenuItem = ({
  onClick,
  subNav,
  className,
  delimiter,
  onSetActiveMenuItem,
  activeMenuItem,
  ...item
}: IBurgerMenuItem) => {
  const toggleBurgerMenu = useAppStore((state) => state.toggleBurgerMenu);

  const { isRouteActive, hasActiveSubNav } = useActiveMenu(item.link, subNav);
  const { isExpanded, contentRef, toggleExpansion } = useAccordion(hasActiveSubNav);

  const handleCloseMenu = useCallback(() => {
    toggleBurgerMenu();
  }, [toggleBurgerMenu]);

  const onBurgerItemClick = useCallback(() => {
    if (onClick) {
      onClick();
    }

    if (!subNav) {
      handleCloseMenu();
      return;
    }

    if (!hasActiveSubNav) {
      onSetActiveMenuItem(item.title);
    }

    toggleExpansion();
  }, [subNav, onClick, handleCloseMenu, hasActiveSubNav]);

  useEffect(() => {
    if (isRouteActive) {
      onSetActiveMenuItem(item.title);
    }
  }, [isRouteActive]);

  return (
    <li key={item.title} aria-expanded={isExpanded} className={clsx(
      "burgerMenuItem",
      delimiter && "hasDelimiter",
      isExpanded && "dropActive",
      className
    )}>
      <MenuItem
        {...item}
        subMenu={!!subNav}
        onClick={onBurgerItemClick}
        isActive={activeMenuItem === item.title}
      />
      {subNav && (
        <div ref={contentRef} className="burgerSubMenu" role="region">
          <ul>
            {subNav.map((item) =>
              <BurgerMenuItem
                {...item}
                key={item.title}
                onSetActiveMenuItem={onSetActiveMenuItem}
                activeMenuItem={activeMenuItem}
              />)}
          </ul>
        </div>
      )}
    </li>
  );
};
